import { Record } from "immutable";

import { PRODUCT_TYPES } from "../../../api/products/productBaseConstants";


const SauceModelRecord = Record({
    amount: '',
    id: '',
    position: '',
    menuSection: null,
    title: '',
    announce: '',
    calories: 0,
    carbohydrates: 0,
    fats: 0,
    proteins: null,
    price: 0,
    subtype: PRODUCT_TYPES.garnish.subtypes.sauce.id,
    type: PRODUCT_TYPES.garnish.id,
    publicImages: [],

    isOnTrade: null,
    isSuitableForCurrentCart: null,
    producerCountry: '',
});

export class SauceModel extends SauceModelRecord {
    //
}
